/**
 * Mode d'affichage de RetailValidationTable pour une commande retail (messika-pwa#25).
 *
 *  - 'validation' : wait_n2 / wait_n1, valideur habilité (N2 sur wait_n2, N1/admin sur wait_n1|wait_n2)
 *  - 'draft'      : brouillon manager new_mgr ouvert par un N1 ou un admin (le N2 garde l'écran de commande)
 *  - null         : écran de commande classique
 */
export type RetailTableMode = 'validation' | 'draft'

export interface RetailTableModeInput {
   status: string
   isRetail: boolean
   isN1: boolean
   isN2: boolean
   isAdmin: boolean
}

export function resolveRetailTableMode({ status, isRetail, isN1, isN2, isAdmin }: RetailTableModeInput): RetailTableMode | null {
   if (!isRetail) return null
   if (status === 'new_mgr') return (isN1 || isAdmin) ? 'draft' : null
   if (status === 'wait_n2') return (isN2 || isN1 || isAdmin) ? 'validation' : null
   if (status === 'wait_n1') return (isN1 || isAdmin) ? 'validation' : null
   return null
}
